export enum USER_ROLES {
  NORMAL_USER = 'normal_user',
  ACCOUNT_ADMIN = 'account_admin',
  ACCOUNT_OWNER = 'account_owner'
}
